import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  startRecording: {
    id: 'donater.form.audio.start_recording',
    defaultMessage: 'Start Recording',
  },
  maxDuration: {
    id: 'donater.form.audio.max_duration',
    defaultMessage: 'Max. duration: {valueInSeconds} sec',
  },
  stopRecording: {
    id: 'donater.form.audio.stop_recording',
    defaultMessage: 'Stop recording',
  },
  delete: {
    id: 'donater.form.audio.delete_recording',
    defaultMessage: 'Delete',
  },
  blocked: {
    id: 'donater.form.audio.blocked',
    defaultMessage: 'To record audio messages, you must allow access to the microphone.',
  },
})
